import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './config/lang/tr.json'; // Import your translation file

i18n.use(initReactI18next).init({
    resources: {
        tr: { translation: tr },
    },
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
